<template>
  <SettingsLayout>
    <Head :title="`${page_name} - Grundeinstellungen`" />

    <template #breadcrumb>{{ page_name }}</template>
    <template #controls>
      <HeaderLink href="/" type="close">Schließen</HeaderLink>
    </template>
    <Heading title="Behandlerurlaub" />
    <p class="max-w-2xl text-sm text-oteoText mb-9">
      Separater Urlaub der einzelnen Mitarbeiter.
    </p>

    <Select class="w-full max-w-sm mr-4 mb-4" v-model="active_user">
      <option value="">Alle</option>
      <option v-for="user in practitioners" :key="user.id" :value="user.id">
        {{ `${user.firstname} ${user.lastname}` }}
      </option>
    </Select>

    <Button
      v-if="canEdit"
      href="/einstellungen/mitarbeiterurlaub/erstellen"
      class="mb-9"
    >
      Neuen Behandlerurlaub anlegen
    </Button>

    <div class="flex flex-col">
      <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden">
            <table class="min-w-full">
              <thead class="bg-white border-b">
                <tr>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Beginn
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Ende
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Behandler/in
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Anmerkung
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                      max-w-xs
                    "
                  >
                    Aktion
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(vac, index) in vacations"
                  :key="vac.id"
                  class="border-b"
                  :class="{ 'bg-gray-100': index % 2 === 0 }"
                >
                  <TD>{{ vac.startString }}</TD>
                  <TD>{{ vac.endString }}</TD>
                  <TD>{{ vac.practitioner.firstname + ' ' + vac.practitioner.lastname }}</TD>
                  <TD>{{ vac.annotation }}</TD>
                  <TD>
                    <div class="flex items-center text-oteo-300">
                      <Link
                        v-if="canEdit"
                        class="mr-4"
                        :href="`mitarbeiterurlaub/${vac.id}/bearbeiten`"
                      >
                        <i class="las la-angle-right"></i>bearbeiten
                      </Link>
                      <div
                        v-if="canDelete"
                        class="cursor-pointer"
                        @click="deleteVacation(vac.id)"
                      >
                        <i class="las la-times"></i>
                        löschen
                      </div>
                    </div>
                  </TD>
                </tr>

                <tr>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </SettingsLayout>
</template>

<script setup>
const page_name = "Urlaub";

let props = defineProps({
  vacations: Array,
  practitioners: Object,
  filters: Object,
});

const canEdit = Inertia.page.props.auth.can["edit settings"];
const canDelete = Inertia.page.props.auth.can["delete settings"];

const active_user = ref(props.filters.active_user);

function deleteVacation(id) {
  Inertia.delete(
    `/employeeVacations/${id}`,
    {},
    { preserveState: true, replace: true }
  );
}

watch(active_user, () => {
  Inertia.get(
    "/einstellungen/mitarbeiterurlaub",
    { mitarbeiter: active_user.value },
    { preserveState: true, replace: true }
  );
});

const form = useForm({});
import TD from "@/Components/Table/Element.vue";

import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Select from "@/Components/Select.vue";
import Label from "@/Components/Settings/Label.vue";
import Button from "@/Components/Button.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Link, Head, useForm } from "@inertiajs/inertia-vue3";
import { ref, watch } from "vue";
import { Inertia } from "@inertiajs/inertia";
</script>
